export default function getTagDefinitions(): string[] {
  return [
    'PVP01', 'JVP01', 'SVP01',
    'PVP02', 'JVP02', 'SVP02',
    'PVP03', 'JVP03', 'SVP03',
    'PVP04', 'JVP04', 'SVP04',
    'PVP05', 'JVP05', 'SVP05',
    'PVP06', 'JVP06', 'SVP06',
    'PVP07', 'JVP07', 'SVP07',
    'PVP08', 'JVP08', 'SVP08',
    'PVP09', 'JVP09', 'SVP09',
    'PVP10', 'JVP10', 'SVP10',
    'PVP11', 'JVP11', 'SVP11',
    'PVP12', 'JVP12', 'SVP12',
    'PVP13', 'JVP13', 'SVP13',
    'PVP14', 'JVP14', 'SVP14',
    'PVP15', 'JVP15', 'SVP15',
    'PVP16', 'JVP16', 'SVP16',
    'PVP17', 'JVP17', 'SVP17',
    'PVP18', 'JVP18', 'SVP18',
    'PVP19', 'JVP19', 'SVP19',
    'PVP20', 'JVP20', 'SVP20',
    'PVP21', 'JVP21', 'SVP21',
    'PVP22', 'JVP22', 'SVP22',
    'PVP23', 'JVP23', 'SVP23',

  ];
}
